// apps/web/src/contexts/NavigationLoaderContext.jsx
// Backward-compat: runWithLoader delegates to LoadingOverlay withLoading.
// Use LoadingOverlayProvider + withLoading from @tennis-matches/ui-components directly for new code.

import React, { createContext, useContext, useCallback, useMemo, useRef } from "react";
import { withLoading, startLoading, stopLoading } from "@tennis-matches/ui-components";

const NavigationLoaderContext = createContext(null);

/** @deprecated Use startLoading/stopLoading from @tennis-matches/ui-components */
export const NAVIGATION_LOADER_SHOW_EVENT = "navigation-loader:show";

export function useNavigationLoader() {
  const ctx = useContext(NavigationLoaderContext);
  return ctx;
}

export function NavigationLoaderProvider({ children }) {
  const loaderTokenRef = useRef(null);
  const runWithLoader = useCallback((fn) => withLoading(fn), []);
  const setShowNavigationLoader = useCallback((value) => {
    if (value) {
      loaderTokenRef.current = startLoading(undefined, { delayMs: 250, minShowMs: 300 });
    } else if (loaderTokenRef.current) {
      stopLoading(loaderTokenRef.current);
      loaderTokenRef.current = null;
    }
  }, []);
  const value = useMemo(
    () => ({
      showNavigationLoader: false,
      setShowNavigationLoader,
      runWithLoader,
    }),
    [setShowNavigationLoader, runWithLoader]
  );
  return (
    <NavigationLoaderContext.Provider value={value}>
      {children}
    </NavigationLoaderContext.Provider>
  );
}
